<template>
  <form :class="{ 'o-50': disabled, 'pe-n': disabled }" @submit="handleSave">
    <div class="f flexed f-gap-16 f-as">
      <div class="f h-x5">
        <label for="test" class="t p-0 m-0" style="white-space: nowrap">Value tag</label>
      </div>
      <div class="f f-gap-4 flexed f-as">
        <div class="f h-x5">
          <span class="t">#</span>
        </div>
        <donut-form-input
          :for="field.hashtag"
          :validators="[presenceValidator('Tag'), hashtagValidator()]"
          class="flexed"
        >
          <donut-input-text
            v-model="field.hashtag"
            v-tooltip="hashtagTooltip"
            :disabled="committed || upgradeRequired"
            class="flexed input-field"
            pattern="[a-zA-Z0-9_]+"
            :max-length="100"
            title="Alphanumeric with underscore(_)"
            placeholder="customersfirst"
          />
        </donut-form-input>
      </div>

      <div class="f f-gap-16">
        <span class="t">Emoji</span>
        <donut-selector-emoji
          :model-value="field.emoji"
          :categories="[
            'foods',
            'activity',
            'nature',
            'places',
            'objects',
            'symbols',
            'flags',
            'people',
            'customSlack',
          ]"
          :disabled="upgradeRequired"
          @update:model-value="($emoji) => (field.emoji = $emoji.id)"
        />
      </div>
      <button
        class="button-reset w-40 h-40 flex f-jc f-ac"
        type="button"
        :class="{ 'o-50': isFieldSetEmpty, 'disabled': isFieldSetEmpty || upgradeRequired }"
        :disabled="isFieldSetEmpty || upgradeRequired"
        @click="handleDelete"
      >
        <lucide-icon name="Trash" :stroke-width="2" :size="24" />
      </button>
    </div>
    <div class="f f-sb f-as f-gap-8 m-tx2 m-l83">
      <donut-form-input
        :for="field.description"
        :validator="presenceValidator('Description')"
        class="w-100p"
      >
        <donut-input-text
          v-model="field.description"
          :textarea="true"
          :max-length="200"
          placeholder="We champion our customers in every decision to drive their success."
          :autogrow="true"
          :disabled="upgradeRequired"
          :wysiwyg="false"
        />
      </donut-form-input>
      <button
        class="button inv p-h10"
        type="submit"
        :class="{ disabled: !isFieldSetComplete }"
        :disabled="!isFieldSetComplete || upgradeRequired"
        :style="{ visibility: dirty ? 'visible' : 'hidden' }"
      >
        Save
      </button>
    </div>
  </form>
</template>
<script setup>
import { computed } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  field: {
    type: Object,
    required: true,
  },
  onDelete: {
    type: Function,
    required: true,
  },
  onSave: {
    type: Function,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  dirty: {
    type: Boolean,
    default: false,
  },
  committed: {
    type: Boolean,
    default: false,
  },
  upgradeRequired: {
    type: Boolean,
    default: false,
  },
});

const isFieldSetEmpty = computed(() => {
  for (const k in props.field) {
    if (k !== 'id' && props.field[k]) {
      return false;
    }
  }
  return true;
});

const isFieldSetComplete = computed(
  () => !Object.values(props.field).some((x) => !x),
);

const handleDelete = (ev) => {
  ev.preventDefault();
  props.onDelete(props.field.id);
};

const handleSave = (ev) => {
  ev.preventDefault();
  props.onSave(props.field.id);
};

const hashtagTooltip = computed(() => (props.committed
  ? {
    content: `<div style='word-break: break-all'>${_.escape(props.field.hashtag)}</div>`,
    // eslint-disable-next-line no-restricted-syntax -- the hashtag is escaped
    html: true,
  }
  : null));
</script>
<style scoped>
.input-field > :deep(input) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
